import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: '[uppercaseInput]'
})
export class UppercaseInputDirective {

    @HostListener('input', ['$event.target'])
    onInput(input: HTMLInputElement) {
        console.log(input.value);
        input.value = input.value.toUpperCase();
    }
}
